import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import './App.css';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'

import DiscoveryItemCard from './DiscoveryItemCard'


class Home extends Component {
  static propTypes = { 
  } 
  state = { 

  } 
  

  render() {
    

    if (this.props.DiscoveryQuery.loading) {      
      return (
          <div className="boardlistpage">
              Loading...
          </div>
      )
    }
    const item = this.props.DiscoveryQuery.discovery[0] ? this.props.DiscoveryQuery.discovery[0] : {}
    return (
      <div>
          <DiscoveryItemCard item={item} />
      </div>
    );
  }
}



const discovery = gql`
query discovery(
  $boardid: String  
  ){
  discovery(
    boardid: $boardid    
  ){
    title
    boardid
    ownedby
    publishedby
    supplierList
    colorList
    categoryList
    createdAt
    updatedAt
    cacheHit
  }  
}`


const HomeWithData = compose(
 graphql(
  discovery, {
    name: 'DiscoveryQuery',
    options: (ownProps) => ({
      variables: {
        boardid: ownProps.match.params.id
      },
      operation: 'query',
    })
  }
),  
)(withRouter(Home))
 
 export default HomeWithData



// WEBPACK FOOTER //
// ./src/DiscoveryDetail.js